import React from 'react';
import { Provider } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { IntercomProvider } from 'react-use-intercom';
import store from './redux/store';
import theme from './config/theme';
import LayoutSelector from './layout/LayoutSelector';

const INTERCOM_APP_ID = 'zi3gts3y';

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <IntercomProvider appId={INTERCOM_APP_ID}>
          <Router>
            <LayoutSelector />
          </Router>
          <ToastContainer
            theme="colored"
            position="top-right"
            autoClose={5000}
            newestOnTop={false}
            closeOnClick={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </IntercomProvider>
      </Provider>
    </MuiThemeProvider>
  );
}

export default App;
